export const OneOnOneSettingsPageReactQueryKeys = {
  oneOnOneAdminAgenda: 'oneOnOneAdminAgenda',
  oneOnOneScoreEnabled: 'oneOnOneScoreEnabled',
  includeTranscriptionBot: 'includeTranscriptionBot',
};
